//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { OPEN_ENDED_THRESHOLD_SECONDS } from '@components/media-filters/videoDurationFilterConstants';

interface VideoDurationRange {
  max: number | undefined;
  min: number;
}

export const parseVideoDurationRange = (
  value: string,
): VideoDurationRange => {
  const [minString, maxString] = value.split('-');
  const parsedMin = Number(minString);
  const parsedMax = maxString ? Number(maxString) : NaN;
  const min = Number.isFinite(parsedMin) ? parsedMin : 0;
  const max = Number.isFinite(parsedMax)
    ? parsedMax
    : OPEN_ENDED_THRESHOLD_SECONDS;
  const normalizedMin = Math.min(min, max);
  const normalizedMax = Math.max(min, max);

  return {
    min: normalizedMin,
    max:
      normalizedMax >= OPEN_ENDED_THRESHOLD_SECONDS
        ? undefined
        : normalizedMax,
  };
};
